var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"right":"","icon":"cached","fill-dot":"","color":"green"}},[_c('span',{attrs:{"slot":"opposite"},slot:"opposite"},[_vm._v("⚀ ⚁ ⚂ ⚃ ⚄ ⚅")]),_c('span',[_vm._v(_vm._s(_vm.data.Result))])])}
var staticRenderFns = []

export { render, staticRenderFns }